<template>
  <v-card outlined>
    <v-card-title class="subtitle-1 pb-2">
      <v-icon left small color="info">mdi-clipboard-check-outline</v-icon>
      Riepilogo Selezioni
    </v-card-title>

    <v-card-text v-if="completedPhases.length === 0" class="text-center">
      <p class="text--secondary mb-0">
        Nessuna fase completata. Seleziona le scelte per ogni fase di lavorazione.
      </p>
    </v-card-text>

    <v-list v-else dense class="pt-0">
      <template v-for="(phaseInfo, idx) in completedPhases">
        <v-divider v-if="idx > 0" :key="phaseInfo.phase.id + '-div'"></v-divider>
        <v-list-item :key="phaseInfo.phase.id" class="px-4">
          <v-list-item-content>
            <v-list-item-title class="d-flex align-center mb-1">
              <v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>
              <span class="font-weight-medium">{{ phaseInfo.phase.title }}</span>
              <v-chip
                v-if="phaseInfo.auto"
                x-small class="ml-2" color="info" outlined
              >auto</v-chip>
            </v-list-item-title>

            <v-list-item-subtitle v-if="phaseInfo.choiceTitle" class="mb-1">
              {{ phaseInfo.choiceTitle }}
            </v-list-item-subtitle>

            <!-- Prodotti -->
            <v-list v-if="phaseInfo.productIds.length > 0" dense class="pa-0 mt-1">
              <ProductListItem
                v-for="productId in phaseInfo.productIds"
                :key="productId"
                :product-id="productId"
                :disabled="isProductDisabled(phaseInfo.phase.id, productId)"
                dense
              />
            </v-list>

            <!-- Procedura (testo troncato) -->
            <div
              v-if="phaseInfo.procedure"
              class="caption text--secondary mt-1"
              style="white-space: pre-line;"
            >
              {{ phaseInfo.procedure }}
            </div>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import ProductListItem from '@/components/ProductListItem';
import { buildPreviouslySelectedProductIds } from '@/utils/wizard-cross-phase';

export default {
  name: 'TestSelectionSummary',

  components: {
    ProductListItem,
  },

  props: {
    phases: {
      type: Array,
      default: () => [],
    },
    phaseSelections: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    previouslySelectedProductIds() {
      return buildPreviouslySelectedProductIds(this.phases, this.phaseSelections);
    },

    completedPhases() {
      if (!this.phases || !this.phases.length) return [];

      return this.phases
        .filter((phase) => {
          const selection = this.phaseSelections[phase.id];
          return selection && selection.complete;
        })
        .map((phase) => {
          const selection = this.phaseSelections[phase.id];
          const hasChoices = phase.choices && phase.choices.length > 0;

          if (selection && selection.complete && hasChoices) {
            // Fase con scelta selezionata: mostra dati della scelta
            const choice = (phase.choices || []).find((c) => c.id === selection.choiceId);
            return {
              phase,
              choiceTitle: selection.choiceTitle || 'Scelta selezionata',
              auto: selection.auto || false,
              productIds: choice && Array.isArray(choice.products) ? choice.products : [],
              procedure: choice ? this.getProcedurePreview(choice) : this.getProcedurePreview(phase),
            };
          }
          // Fase senza scelte (solo procedura)
          return {
            phase,
            choiceTitle: null,
            auto: false,
            productIds: [],
            procedure: this.getProcedurePreview(phase),
          };
        });
    },
  },

  methods: {
    isProductDisabled(phaseId, productId) {
      const selected = this.previouslySelectedProductIds[phaseId];
      return selected ? selected.has(productId) : false;
    },

    hasProcedure(item) {
      return item && item.procedure != null && String(item.procedure).trim() !== '';
    },

    getProcedurePreview(item) {
      if (!item || !item.procedure) return null;
      let raw = '';
      if (typeof item.procedure === 'string') {
        raw = item.procedure;
      } else if (typeof item.procedure === 'object') {
        raw = item.procedure.it || '';
      }
      const plain = raw.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      if (!plain) return null;
      if (plain.length <= 200) return plain;
      // eslint-disable-next-line prefer-template
      return plain.slice(0, 200) + '…';
    },
  },
};
</script>
